import { TrackedHandler } from './tracked-handler';

export enum IntersectionDirection {
    NONE = 'none',
    UP = 'up',
    DOWN = 'down',
}

export interface onListTopCallbackArgs {
    evt: WheelEvent;
    resetHandlers: () => void;
}

export type OnListTopCallback = (args: onListTopCallbackArgs) => void;

export interface useIntersectionObserverResult {
    observer: IntersectionObserver;
    setTopElement: (topElement: HTMLElement, callback: IntersectionObserverCallback, options?: Object) => void;
    topElement: Element;
    trackElement: TrackElement;
    resetHandlers: () => void;
    trackedHandlers: TrackedHandlerList;
}

export type QueryCallback = (entry: IntersectionObserverEntry, tracking_id: string) => boolean;

export interface TrackedQuery {
    query: string;
    callback?: QueryCallback;
}

export type TrackedHandlerList = { [k: string]: TrackedHandler };

export type TrackElement = (query: string, callback?: QueryCallback) => void;

export interface useObservedTrackerResult {
    trackElement: TrackElement;
    resetHandlers: () => void;
    trackedHandlers: TrackedHandlerList;
}
